var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-context-screen"},[_c('div',{staticClass:"inner"},[_c('a-spin',{attrs:{"size":"large"}}),_c('div',{staticClass:"loading-text"},[_vm._v(" Loading... ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }